import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { fUserRole } from '../../../utils/formatEnums';

function NewMemberDialog({ open, setOpen, saveMember, managedRoles, saveMemberStatus }) {
  const [values, setValues] = React.useState({
    email: undefined,
    role: undefined,
    dptoNumber: undefined
  });

  const handleSubmit = () => {
    saveMember(values)
      .then(() => {
        setOpen(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  console.log({ saveMemberStatus });

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Nuevo miembro</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          onChange={(e) => handleChange('email', e.target.value)}
        />
        <FormControl fullWidth>
          <InputLabel id="role-select-label">Rol</InputLabel>
          <Select
            labelId="role-select-label"
            id="role-select"
            value={values.role}
            label="Age"
            onChange={(e) => handleChange('role', e.target.value)}
          >
            {managedRoles &&
              managedRoles.map((role) => <MenuItem value={role}>{fUserRole(role)}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          autoFocus
          margin="dense"
          id="dpto"
          label="Dpto"
          type="dpto"
          fullWidth
          variant="outlined"
          onChange={(e) => handleChange('dptoNumber', e.target.value)}
        />
      </DialogContent>
      {saveMemberStatus.error && (
        <Typography sx={{ ml: 'auto', mr: 2 }} variant="body1" color="error">
          {saveMemberStatus.error.message}
        </Typography>
      )}
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <LoadingButton
          loading={saveMemberStatus.loading}
          variant="contained"
          onClick={handleSubmit}
        >
          Aceptar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

const mapState = (state) => ({
  managedRoles: state.property.managedRoles,
  saveMemberStatus: state.loading.effects.property.saveMember
});

const mapDispatch = (dispatch) => ({
  saveMember: dispatch.property.saveMember
});

export default connect(mapState, mapDispatch)(NewMemberDialog);
